module.exports = __webpack_public_path__ + "static/icon-heart-982486d321dd4befbc1b1fd664cf77f9.png";